module.exports = __webpack_public_path__ + "static/media/proposition.38306c3b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/form/proposition.pdf
// module id = 836
// module chunks = 40